var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{attrs:{"id":"myCanvas","width":"55","height":"20"}},[_vm._v(_vm._s(_vm.$t('testquestioncaptcha.yourBrowserDoes')))]),_c('v-text-field',{staticClass:"py-0",attrs:{"rules":[
      _vm.validations.required(_vm.$t('testquestioncaptcha.captcha')),
      _vm.correctOutput
    ],"persistent-hint":"","hint":_vm.$t('testquestioncaptcha.hint'),"type":"number"},model:{value:(_vm.output),callback:function ($$v) {_vm.output=$$v},expression:"output"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }